<template>
  <div id="top-main">
    <div class="inner-main" :dir="uiDirection">
    <div id="container-header" class="container-header">
      <header-main></header-main>
      <nav-category mode="main"></nav-category>
    </div>
      <slot></slot>
    </div>
    <cart></cart>
  </div>
</template>
<style lang='scss'>
  @import '../assets/css/category.css';
</style>
<script>
import {
  mapGetters
} from 'vuex'

import HeaderMain from '../components/partials/HeaderMain.vue'
import NavCategory from '../components/partials/NavCategory.vue'
import Cart from '../components/partials/Cart.vue'

export default {
  computed: {
    ...mapGetters({
      uiDirection: 'uiDirection'
    }),
    layout () {
      return (this.$route.meta.layout || defaultLayout) + '-layout'
    }
  },
  mounted () {
    let body = document.body

    body.classList.add('mainpage')
  },
  components: {
    HeaderMain,
    NavCategory,
    Cart
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/Main.vue